import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ['elementToHide']

  hide(event) {
    this.elementToHideTarget.classList.add('is-hidden');
  }
}